import Navigation from './navigation';
import AccountLinks from './accountLinks';
import Wordmark from '../common/wordmark';

import { useSelector } from 'react-redux';
import './style.scss';
import CurrentDistrict from "../currentDistrict";
import {checkIfLoggedInOrTermsAndConditions} from "../../utils/session";

const Header = (props) => {
  const loggedIn = useSelector((state) => state.session.loggedIn);
  const mustAcceptTermsAndConditions = useSelector((state) => state.session.mustAcceptTermsUser);

  return (
    <header className='primary-header'>
      <div className='header-main-contents'>
        <Wordmark />

        <div className='nav-row'>
          { !checkIfLoggedInOrTermsAndConditions(mustAcceptTermsAndConditions, loggedIn) &&  <AccountLinks /> }
          <Navigation />
        </div>

      </div>

      {loggedIn &&
        <div className='district-row'>
          <CurrentDistrict />
        </div>
      }

      <div className="header-extra-contents">

        { props.children }
      </div>

    </header>
  );
};

export default Header;
